import React, { useState, useEffect, useRef } from 'react';

import classes from './styles.module.scss';

function formatTimeInMinutes(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export default function Timestamp({
  left,
  section,
  scrollWidth,
  isFirst,
  isLast,
}) {
  const [timestamp, setTimestamp] = useState(0);

  const timestampRef = useRef();
  const spanRef = useRef();

  useEffect(() => {
    if (isFirst) {
      setTimestamp(0);
      return;
    }

    if (timestampRef.current && spanRef.current) {
      const duration = section?.duration || 0;
      const { offsetLeft } = timestampRef.current;
      const spanWidth = spanRef.current.offsetWidth;

      const time = Math.round(
        (duration / scrollWidth) *
          (offsetLeft + (isLast ? -spanWidth / 2 : spanWidth / 2))
      );
      setTimestamp(time);
    }
  }, [scrollWidth, section?.duration, isFirst, isLast]);

  return (
    <div
      className={classes.Timestamp}
      ref={timestampRef}
      style={{
        left,
      }}
    >
      <span ref={spanRef}>{formatTimeInMinutes(timestamp)}</span>
    </div>
  );
}
